module.exports = __webpack_public_path__ + "assets/dashboard-icon-percentageExposedToVidjet.169b0df1.svg";